<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ConfirmationDialog',
  props: ['text', 'buttons', 'title'],
  methods: {
    action(handler) {
      this.$emit('close')
      if (handler) {
        handler()
      }
    }
  }
})
</script>
<template>
  <section class="container">
    <header class="dialog-header" v-if="title">
      <h1>{{ title }}</h1>
    </header>
    <main class="dialog-content">
      {{ text }}
    </main>
    <div class="vue-dialog-buttons">
      <button
        v-for="button in buttons"
        :key="button.title"
        :class="button.class"
        @click="action(button.handler)"
        type="button"
        tabindex="0"
      >
        {{ button.title }}
      </button>
    </div>
  </section>
</template>
